import { takeEvery, takeLatest, fork, put, all, call, select } from "redux-saga/effects";
import {
    getPetsError,
    getPetsSuccessful,
    addPetError,
    addPetSuccessful,
    showAddPetModalSuccess,
    removePetError,
    removePetSuccess,
    getPets,
    editPetError,
    editPetSuccess, adoptedShelterPetSuccess, adoptedShelterPetError,
    setPetQuery
} from "./actions";
import PetService from "./service";
import { PetActionTypes } from "./actionTypes";
import {userRols} from "../../helpers/userRols";
import { mergeListQuery } from "helpers/listQuery";

// Selector to get the pet query state from the Redux store.
export const getPetQuery = state => state.Pet.query;

export function* get({payload}) {
    try {
        // Get the current query from the Redux store.
        const storedQuery = yield select(getPetQuery);
        // The payload overrides the stored query; switching between parent and
        // shelter pets starts on page 1 with no search term (both share it).
        const finalPayload = mergeListQuery(storedQuery, payload, 'role');
        const response = yield call(PetService.getPets, finalPayload);
        yield put(getPetsSuccessful(response));
        yield put(setPetQuery(finalPayload));
    } catch (error) {
        yield put(getPetsError(error));
    }
}

function* addPet({ payload: pet }) {
    try {
        const response = yield call(PetService.addPet, pet);
        yield put(addPetSuccessful(response));
        yield put(getPets());
        
    } catch (error) {
        yield put(addPetError(error));
    }
}

function* showAddPet({ payload: showModal }) {
    yield put(showAddPetModalSuccess(showModal));
}

function* removePet({ payload: petId }) {
    try {
        const response = yield call(PetService.removePet, petId);
        yield put(removePetSuccess(response));
        yield put(getPets());
    } catch (error) {
        yield put(removePetError(error));
    }
}

function* edit({ payload: pet }) {
    try {
        const response = yield call(PetService.editPet, pet);
        yield put(editPetSuccess(response));
        yield put(getPets());
    } catch (error) {
        yield put(editPetError(error));
    }
}

function* adopted({ payload: petId }) {
    try {
        const response = yield call(PetService.adoptedPet, {petId});
        yield put(adoptedShelterPetSuccess(response));
        yield put(getPets({role: userRols.shelter}));
    } catch (error) {
        yield put(adoptedShelterPetError(error));
    }
}

export function* watchGetPet() {
    yield takeLatest(PetActionTypes.PET_LIST_GET, get);
}

export function* watchAddPet() {
    yield takeEvery(PetActionTypes.PET_ADD, addPet);
}

export function* watchShowAddPetModal() {
    yield takeEvery(PetActionTypes.PET_ADD_MODAL, showAddPet);
}

export function* watchRemovePet() {
    yield takeEvery(PetActionTypes.PET_REMOVE, removePet);
}

export function* watchEditPet() {
    yield takeEvery(PetActionTypes.PET_EDIT, edit);
}
export function* watchAdoptedPet() {
    yield takeEvery(PetActionTypes.PET_SHELTER_ADOPTED, adopted);
}

function* petsSaga() {
    yield all([
        fork(watchGetPet),
        fork(watchAddPet),
        fork(watchShowAddPetModal),
        fork(watchRemovePet),
        fork(watchEditPet),
        fork(watchAdoptedPet)
    ]);
}

export default petsSaga;
